import React from "react";
import l from "components/util/l";
import STEPS from "components/brief/reviewer/revision/content/cover/RevisionInstructions.lib.steps";

const RevisionInstructions = ({ onClickNext }) => (
  <div className="col-12 h-100 d-flex flex-column overflow-auto rounded"
    style={{ maxWidth: "65rem", borderRadius: "1rem" }}>

    <div className="flex-fill d-flex flex-column align-items-center justify-content-start p-2 p-md-5">
      <div style={{ maxWidth: "1200px" }}>

        {/* Header */}
        <div className="text-center mt-1  mb-5">
          <h1 className="text-white display-4">{l("Instrucciones%PA519")}</h1>
          <label className="mb-0" style={{ color: "#ffffffa0" }}>{l("Sigue estos pasos para revisar tu propuesta inicial%PA534")}</label>
        </div>

        {/* Steps */}
        <div className="row">
          {STEPS.map((step, idx) => (
            <div key={idx} className={`col-12 col-md-4 mb-4 animate__animated animate__fadeInUp`} 
            style={{ animationDelay: `${idx * 0.32}s` }}>
              <div
                className="h-100 rounded p-4"
                style={{ border: "1px solid #e8edf3", background: "#fafbfd" }}
              >

                {/* Step header */}
                <div className="d-flex align-items-top mb-3">
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mr-3 flex-shrink-0"
                    style={{
                      width: "40px",
                      height: "40px",
                      background: step.iconBg,
                    }}
                  >
                    <i className={`${step.icon}`} style={{ color: step.iconColor, fontSize: "1rem" }}></i>
                  </div>
                  <div>
                    <span
                      className="font-weight-bold text-dark"
                      style={{ fontSize: "0.9rem", lineHeight: 1.3, display: "block" }}
                    >
                      {l(step.titleKey)}
                    </span>
                  </div>
                </div>

                {/* Mockup illustration */}
                <div className="mb-3">{step.mockup}</div>

                {/* Description */}
                <p className="text-muted mb-0" style={{ fontSize: "0.83rem", lineHeight: 1.6 }}>
                  {l(step.descKey)}
                </p>

              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button className="btn btn-primary btn-lg w-100 mt-2" onClick={onClickNext}>
          <i className="fas fa-play mr-2" /> {l("Empezar%PA279")}
        </button>

      </div>
    </div>
  </div>
);

export default RevisionInstructions;
